<template>
  <div class="linkage">
    <Table :table-config="tableConfig" :templateData="tableData"></Table>
    <div class="table-bottom" @click="searchUser(true)">添加成员</div>
    <div class="im-box">
      <webSock :groupId="alarmId" ref="webSock" :size="10"></webSock>
    </div>

    <el-dialog title="添加成员" :visible.sync="dialogShow" width="30%">
      <div class="add-member">
        <p class="tabel-button">
          <span :class="{ selected: srarchUserType }" @click="searchUser(true)"
            >直属上级</span
          >
          <span :class="{ selected: !srarchUserType }" @click="searchUser(false)"
            >出警人员</span
          >
        </p>
        <Table :table-config="tableConfig1" :templateData="tableData1"></Table>
      </div>

      <p slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="addUser()">确 定</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { mapAPI } from "../../../../../api-path/command-center";
export default {
  name: "linkage",
  data() {
    return {
      showHistory: false,
      dialogShow: false,
      srarchUserType: true,
      content: "",
      groupId: "", //群成员ID
      alarmId: "", //报警ID
      tableData: [],
      tableConfig: {
        height: 150,
        rows: [
          {
            label: "姓名",
            prop: "realName",
          },
          {
            label: "联系电话",
            prop: "phone",
            width: "150px",
          },
        ],
        rowButtons: {
          items: [
            {
              icon: "el-icon-search",
              fn: (data) => {
                this.$emit("getTrack", data.id);
              },
            },
          ],
        },
      },
      tableData1: [],
      selectData: [],
      tableConfig1: {
        checkbox: true,
        checkboxFn: (data) => {
          this.selectData = data;
        },
        rows: [
          {
            label: "姓名",
            prop: "realName",
          },
          {
            label: "联系电话",
            prop: "phone",
            width: "150px",
          },
        ],
      },
      chattingRecords: [],
    };
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
    this.alarmId = this.$store.state.alarmId;
    this.getData();
  },
  methods: {
    getData() {
      const $this = this;
      this.$http.get(mapAPI.getGroupUserInfo + "?groupId=" + this.groupId).then((res) => {
        if (res.status === 200) {
          this.tableData = res.result;
          let notGroupMember = JSON.parse(
            JSON.stringify($this.$store.state.notGroupMember)
          );
          notGroupMember[this.groupId] = res.result;
          this.$store.commit("setGroupMember", notGroupMember);
        }
      });
    },

    searchUser(type) {
      this.srarchUserType = type;
      this.dialogShow = true;
      this.selectData = [];
      let params = {
        alarmId: this.alarmId,
        isUp: type,
      };
      this.$http
        .get(mapAPI.getPoliceUser, {
          params,
        })
        .then((res) => {
          if (res.status === 200) {
            if (type) {
              this.tableData1 = res.result["直属上级"];
            } else {
              this.tableData1 = res.result["在线出警员"];
            }
          }
        });
    },

    addUser() {
      let params = [];
      this.selectData.forEach((item) => {
        params.push({
          groupId: this.alarmId,
          in: true,
          ownerId: "",
          type: false,
          userId: item.id,
        });
      });

      this.$http.post(mapAPI.addOrRemoveMeeting, params).then((res) => {
        if (res.status === 200) {
          this.dialogShow = false;
          this.$message.success("添加成功");
          this.getData();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "linkage.less";
</style>
